/*@flow*/
import L from 'leaflet';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

type IconOptionsT = {
  type: 'div',
  iconSize: number[],
  iconAnchor: number[],
  className: string,
};

type OptionsT = {
  latlon: number[],
  latlng?: number[],
  icon?: Leaflet$Icon,
  iconOptions?: IconOptionsT,
  opacity?: number,
};

const getIcon = (iconOptions) => {
  if (!iconOptions) return;
  const {
    iconSize = [25, 41],
    iconAnchor = [13, 37],
    className = 'marker',
    type,
  } = iconOptions;
  let opts = {
    iconSize: L.point(iconSize),
    iconAnchor: L.point(iconAnchor),
    className,
  };
  if (type && type === 'div') {
    return L.divIcon(opts);
  }
  return new L.Icon.Default(opts);
};

function Marker(props: DeckPropsT<OptionsT>) {
  const { options } = props;
  const [element, setElement] = useState();
  let { latlon, latlng, opacity, iconOptions } = options;
  const val = latlon || latlng;

  // Add/remove marker
  useEffect(() => {
    if (!val) return;
    const loc = L.latLng(val);
    const icon = getIcon(iconOptions);
    const markerOpts = icon ? { ...options, icon } : options;
    const el: Leaflet$Marker = L.marker(loc, markerOpts);
    icon && el.setIcon(icon);
    setElement(() => el);
  }, []);

  // Update latlng
  useEffect(() => {
    element && val && element.setLatLng(val);
  }, [latlon, latlng]);

  // Update opacity
  useEffect(() => {
    element && opacity && element.setOpacity(opacity);
  }, [opacity]);

  useLayer<OptionsT>(props, element);
}

export default Marker;
